import { handleActions } from 'redux-actions';
import { mergeLeft, assoc, pipe } from 'ramda';
import { mergeCareTeam } from 'utilities/fhir/organization';

import {
  requestAllPractitionersSuccess,
  requestOrganization,
  fetchOrganization,
  requestOrganizationSuccess,
} from 'store/actionCreators/organization';
import { handleOrganizationResponse } from 'store/selectors/organization';

// Reuse reducer for add/edit site flow
const defaultState = {
  practionersLoading: true,
  practitioners: [],
  initial: true,
  fetching: false,
  fetched: false,
  data: null,
};

export default handleActions(
  {
    [requestAllPractitionersSuccess]: (state, { payload }) =>
      pipe(
        assoc('practionersLoading', false),
        assoc('practitioners', mergeCareTeam(payload)),
      )(state),
    [fetchOrganization]: mergeLeft(defaultState),
    [requestOrganization]: mergeLeft({
      initial: false,
      fetching: true,
    }),
    [requestOrganizationSuccess]: (state, { payload }) =>
      mergeLeft(
        {
          initial: false,
          fetching: false,
          fetched: true,
          data: handleOrganizationResponse(payload),
        },
        state,
      ),
  },
  defaultState,
);
